module.exports = __webpack_public_path__ + "img/blog2.5d824e98.jpg";